import { render, staticRenderFns } from "./DeclarationsWidget.vue?vue&type=template&id=67a9dc46"
import script from "./DeclarationsWidget.vue?vue&type=script&lang=js"
export * from "./DeclarationsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports